module.exports = __webpack_public_path__ + "img/SlideShow05.73784d41.jpg";